export default __webpack_public_path__ + "static/column-trainer-1-01c689c02b8449e6189df18f8646eba9.jpg";